(() => {
  const SKIN_REPORT_SECTIONS_URL = '/';

  const getSection = () => document.querySelector('.skin-report-serums');
  const getConfig = () => document.getElementById('skin-report-serums-config');
  const getCartElement = () =>
    document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const toAbsoluteUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    if (url.startsWith('//')) return `${window.location.protocol}${url}`;
    if (url.startsWith('/')) return `${window.location.origin}${url}`;
    return url;
  };

  const normalizeVariantId = (value) => {
    if (!value) return '';
    const raw = String(value).trim();
    if (!raw) return '';
    if (raw.includes('/')) return raw.split('/').pop();
    return raw;
  };

  const buildContextFromSection = () => {
    const section = getSection();
    const config = getConfig();
    if (!section) return null;

    const variantIds = ['dayVariantId', 'nightVariantId']
      .map((key) => normalizeVariantId(config?.dataset[key]))
      .filter(Boolean);

    return {
      handle: section.dataset.skinReportHandle,
      pageUrl: toAbsoluteUrl(section.dataset.skinReportPageUrl),
      pdfUrl: toAbsoluteUrl(section.dataset.skinReportPdfUrl),
      printedPropertyName:
        section.dataset.skinReportPrintedPropertyName || 'Skin Report imprimé',
      printedIncludedLabel: section.dataset.skinReportPrintedIncludedLabel || 'Inclus (gratuit)',
      variantIds,
      pendingPrompt: true,
    };
  };

  const showAddToCartError = (form, message) => {
    const errorEl = form.querySelector('.skin-report-serum-atc__error');
    if (!errorEl || !message) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  };

  const clearAddToCartError = (form) => {
    const errorEl = form.querySelector('.skin-report-serum-atc__error');
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  };

  const initSkinReportSerumCart = () => {
    if (!getSection()) return;

    document.querySelectorAll('.skin-report-serum-atc__form').forEach((form) => {
      if (form.dataset.cartBound === 'true') return;
      form.dataset.cartBound = 'true';

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clearAddToCartError(form);

        const button = form.querySelector('[type="submit"]');
        const spinner = form.querySelector('.loading__spinner');
        if (!button || button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        const cart = getCartElement();
        const variantId = form.querySelector('[name="id"]')?.value;
        if (!variantId) {
          showAddToCartError(form, 'Product unavailable.');
          return;
        }

        const context = buildContextFromSection();
        if (context?.handle && window.SkinReportCartDrawer?.saveContext) {
          window.SkinReportCartDrawer.saveContext(context);
        }

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        spinner?.classList.remove('hidden');

        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: {} };
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(form);
        if (context?.handle) {
          formData.set('properties[_skin_report_handle]', context.handle);
          if (context.pageUrl) formData.set('properties[_skin_report_page_url]', context.pageUrl);
          if (context.pdfUrl) formData.set('properties[_skin_report_pdf_url]', context.pdfUrl);
        }

        if (cart?.getSectionsToRender) {
          const sections = cart
            .getSectionsToRender()
            .map((section) => section.section)
            .join(',');
          if (sections) {
            formData.set('sections', sections);
          }
          formData.set('sections_url', SKIN_REPORT_SECTIONS_URL);
          cart.setActiveElement?.(document.activeElement);
        }
        config.body = formData;

        const cartAddUrl =
          (typeof routes !== 'undefined' && routes.cart_add_url) ||
          window.routes?.cart_add_url ||
          '/cart/add.js';

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              showAddToCartError(form, response.description || 'Unable to add to cart.');
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'skin-report-serum',
                productVariantId: variantId,
                cartData: response,
              });
            }

            if (cart) {
              try {
                cart.renderContents(response);
                if (cart.classList.contains('is-empty')) {
                  cart.classList.remove('is-empty');
                }
              } catch (error) {
                console.error('Skin report cart drawer update failed:', error);
                window.location = window.routes?.cart_url || '/cart';
                return;
              }
            } else {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }

            if (typeof updateCartCounters === 'function') {
              updateCartCounters();
            }

            document.dispatchEvent(new CustomEvent('skin-report:serum-added'));
            window.SkinReportCartDrawer?.syncCartOptionsPanel?.();
          })
          .catch((error) => {
            console.error('Skin report add to cart failed:', error);
            showAddToCartError(form, 'Unable to add to cart. Please try again.');
          })
          .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkinReportSerumCart);
  } else {
    initSkinReportSerumCart();
  }
})();
